/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Faq_Free_AInputs */

const en_gc_resources_faq_free_a = /** @type {(inputs: Gc_Resources_Faq_Free_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The upstream GridCraft project is free to use and dual-licensed under MIT and Apache 2.0. Its source code is available on GitHub.`)
};

const zh_gc_resources_faq_free_a = /** @type {(inputs: Gc_Resources_Faq_Free_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。官方 GridCraft 项目可免费使用，采用 MIT 与 Apache 2.0 双重许可，源码可在 GitHub 获取。`)
};

/**
* | output |
* | --- |
* | "Yes. The upstream GridCraft project is free to use and dual-licensed under MIT and Apache 2.0. Its source code is available on GitHub." |
*
* @param {Gc_Resources_Faq_Free_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_faq_free_a = /** @type {((inputs?: Gc_Resources_Faq_Free_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Faq_Free_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_faq_free_a(inputs)
	return zh_gc_resources_faq_free_a(inputs)
});
export { gc_resources_faq_free_a as "gc.resources.faq.free.a" }